export default "__VITE_ASSET__F4zhZn9C__"